require('./playerController');

require('./jwPlayer/jwPlayerDirective');
require('../shared/leagueLookIn/leagueLookInDirective');
require('../shared/switchToggle/switchToggleDirective');

require('./analysis/analysisController');
require('./hotkeys/hotkeysController');
require('./lines/linesController');
require('./tagEvent/tagEventController');
require('./timeline/timelineController');
require('./roster/rosterController');
require('./clips/clipsController');
require('./boxscore/boxscoreController');

require('./telestrate/telestrateControls/telestrateControlsDirective');
require('./telestrate/telestrateCanvas/telestrateCanvasDirective');
require('../shared/clockTimeUnit/clockTimeUnitDirective');

require('../shared/clipFilter');

'use strict';

angular.module('app.player', [
  'app.player.playerController',
  'app.player.jwPlayer.jwPlayerDirective',
  'app.shared.leagueLookIn.leagueLookInDirective',
  'app.shared.switchToggle.switchToggleDirective',

  'app.player.analysisController',
  'app.player.hotkeysController',
  'app.player.linesController',
  'app.player.tagEventController',
  'app.player.timelineController',
  'app.player.rosterController',
  'app.player.clipsController',
  'app.player.boxscoreController',

  'app.player.telestrate.telestrateControlsDirective',
  'app.player.telestrate.telestrateCanvasDirective',
  'app.shared.clockTimeUnit.clockTimeUnitDirective',

  'app.shared.clipFilter'
])
  .config([
    '$stateProvider',
    function ($stateProvider) {
      let params = {
        url: '/play/:type/:id?:audio',
        title: 'Video Player',
        views: {
          '': {
            templateUrl: 'components/player/playerView.html',
            controller: 'app.player.playerController'
          },
          'analysis@app.play': {
            templateUrl: 'components/player/analysis/analysisView.html',
            controller: 'app.player.analysisController'
          },
          'hotkeys@app.play': {
            templateUrl: 'components/player/hotkeys/hotkeysView.html',
            controller: 'app.player.hotkeysController'
          },
          'lines@app.play': {
            templateUrl: 'components/player/lines/linesView.html',
            controller: 'app.player.linesController'
          },
          'tagEvent@app.play': {
            templateUrl: 'components/player/tagEvent/tagEventView.html',
            controller: 'app.player.tagEventController'
          },
          'timeline@app.play': {
            templateUrl: 'components/player/timeline/timelineView.html',
            controller: 'app.player.timelineController'
          },
          'roster@app.play': {
            templateUrl: 'components/player/roster/rosterView.html',
            controller: 'app.player.rosterController'
          },
          'clips@app.play': {
            templateUrl: 'components/player/clips/clipsView.html',
            controller: 'app.player.clipsController'
          },
          'boxscore@app.play': {
            templateUrl: 'components/player/boxscore/boxscoreView.html',
            controller: 'app.player.boxscoreController'
          }
        },
        fullWidthMobile: true,

        params: {
          clip_edit: false
        }
      };

      $stateProvider
        .state('app.play', params);
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/player/player.js